import { Link } from "react-router-dom";
import { useThemePreview } from "../themePreview";

function LuncheonScreen() {
  const { images } = useThemePreview();

  return (
    <div className="beach">
      <section className="page-banner" style={{ backgroundImage: `url(${images.luncheon})` }}>
        <div className="site-wrap">
          <p className="site-kicker">VIP luncheon</p>
          <h1>Lunch on show day</h1>
          <p>A seated meal while the cars are on the lawn. The menu and prices belong to that event's luncheon.</p>
        </div>
      </section>

      <section className="site-section">
        <div className="site-wrap split">
          <img className="split-photo" src={images.luncheon} alt="" />
          <div>
            <h2>What you will see here</h2>
            <ul className="plain-list">
              <li>The luncheon name and who is hosting it</li>
              <li>The menu</li>
              <li>Ticket choices and prices</li>
            </ul>
            <p className="quiet">Those details are saved with the event. This page is the place they will land.</p>
            <Link className="text-link" to="/show">
              Back to the weekend
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LuncheonScreen;
